import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\OptionalController::store
* @see app/Http/Controllers/Admin/OptionalController.php:37
* @route '/dashboard/optionals/categories'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/dashboard/optionals/categories',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\OptionalController::store
* @see app/Http/Controllers/Admin/OptionalController.php:37
* @route '/dashboard/optionals/categories'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\OptionalController::store
* @see app/Http/Controllers/Admin/OptionalController.php:37
* @route '/dashboard/optionals/categories'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\OptionalController::store
* @see app/Http/Controllers/Admin/OptionalController.php:37
* @route '/dashboard/optionals/categories'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\OptionalController::store
* @see app/Http/Controllers/Admin/OptionalController.php:37
* @route '/dashboard/optionals/categories'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\OptionalController::update
* @see app/Http/Controllers/Admin/OptionalController.php:72
* @route '/dashboard/optionals/categories/{optionalCategory}'
*/
export const update = (args: { optionalCategory: string | number | { id: string | number } } | [optionalCategory: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/dashboard/optionals/categories/{optionalCategory}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\OptionalController::update
* @see app/Http/Controllers/Admin/OptionalController.php:72
* @route '/dashboard/optionals/categories/{optionalCategory}'
*/
update.url = (args: { optionalCategory: string | number | { id: string | number } } | [optionalCategory: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { optionalCategory: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { optionalCategory: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            optionalCategory: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        optionalCategory: typeof args.optionalCategory === 'object'
        ? args.optionalCategory.id
        : args.optionalCategory,
    }

    return update.definition.url
            .replace('{optionalCategory}', parsedArgs.optionalCategory.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\OptionalController::update
* @see app/Http/Controllers/Admin/OptionalController.php:72
* @route '/dashboard/optionals/categories/{optionalCategory}'
*/
update.put = (args: { optionalCategory: string | number | { id: string | number } } | [optionalCategory: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\OptionalController::update
* @see app/Http/Controllers/Admin/OptionalController.php:72
* @route '/dashboard/optionals/categories/{optionalCategory}'
*/
const updateForm = (args: { optionalCategory: string | number | { id: string | number } } | [optionalCategory: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\OptionalController::update
* @see app/Http/Controllers/Admin/OptionalController.php:72
* @route '/dashboard/optionals/categories/{optionalCategory}'
*/
updateForm.put = (args: { optionalCategory: string | number | { id: string | number } } | [optionalCategory: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\OptionalController::destroy
* @see app/Http/Controllers/Admin/OptionalController.php:96
* @route '/dashboard/optionals/categories/{optionalCategory}'
*/
export const destroy = (args: { optionalCategory: string | number | { id: string | number } } | [optionalCategory: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/dashboard/optionals/categories/{optionalCategory}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\OptionalController::destroy
* @see app/Http/Controllers/Admin/OptionalController.php:96
* @route '/dashboard/optionals/categories/{optionalCategory}'
*/
destroy.url = (args: { optionalCategory: string | number | { id: string | number } } | [optionalCategory: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { optionalCategory: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { optionalCategory: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            optionalCategory: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        optionalCategory: typeof args.optionalCategory === 'object'
        ? args.optionalCategory.id
        : args.optionalCategory,
    }

    return destroy.definition.url
            .replace('{optionalCategory}', parsedArgs.optionalCategory.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\OptionalController::destroy
* @see app/Http/Controllers/Admin/OptionalController.php:96
* @route '/dashboard/optionals/categories/{optionalCategory}'
*/
destroy.delete = (args: { optionalCategory: string | number | { id: string | number } } | [optionalCategory: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\OptionalController::destroy
* @see app/Http/Controllers/Admin/OptionalController.php:96
* @route '/dashboard/optionals/categories/{optionalCategory}'
*/
const destroyForm = (args: { optionalCategory: string | number | { id: string | number } } | [optionalCategory: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\OptionalController::destroy
* @see app/Http/Controllers/Admin/OptionalController.php:96
* @route '/dashboard/optionals/categories/{optionalCategory}'
*/
destroyForm.delete = (args: { optionalCategory: string | number | { id: string | number } } | [optionalCategory: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const categories = {
    store: Object.assign(store, store),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default categories